<template>
  <!-- spread attributes-->
  <input :value="formattedValue" @input="onInput" @focus="focus = true" @blur="focus = false" v-bind="$attrs"
    type="text" />
</template>

<script>
export default {
  name: 'FormatInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: [String, Number],
    currency: Boolean
  },
  data() {
    return {
      focus: false,
    }
  },
  methods: {
    onInput(event) {
      let val = event.target.value;
      if (!val) val = 0;
      else val = parseFloat(val);
      this.$emit('input', val)
    }
  },
  computed: {
    formattedValue() {
      if (this.focus) {
        return this.value
      }

      if (this.currency)
        return new Intl.NumberFormat("fr-FR", { style: 'currency', currency: 'EUR' }).format(this.value);
      else
        return new Intl.NumberFormat("fr-FR", {}).format(this.value);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/InputFormattedNumber.vue